import { mixinRobotoFont } from '@genesislcap/foundation-zero';
import { css } from '@microsoft/fast-element';
export const MainStyles = css `
  ${mixinRobotoFont()}
  :host {
    contain: content;
  }

  :host,
  zero-design-system-provider,
  .dynamic-template,
  foundation-router {
    display: flex;
    width: 100%;
    height: 100%;
  }

  fast-progress {
    --accent-foreground-rest: #654df9;

    height: calc(var(--design-unit) * 1px);
    margin: 0;
    width: 100%;
  }
`;
